export default __webpack_public_path__ + "static/media/10_blake_marco.33281f80.jpg";